import { loadImage } from './mapUtil';

import planeIcon from '../resources/images/icons/plane.png';
import markerRedIcon from '../resources/images/icons/marker-red.png';
import markerGreenIcon from '../resources/images/icons/marker-green.png';
import markerBlueIcon from '../resources/images/icons/marker-blue.png';

export const mapIcons = {
  plane: planeIcon,
  marker_red: markerRedIcon,
  marker_green: markerGreenIcon,
  marker_blue: markerBlueIcon
};

export const mapImages = {};

export default async () => {
  await Promise.all(
    Object.keys(mapIcons).map(async (category) => {
      const results = [];
      results.push(
        loadImage(mapIcons[category]).then((icon) => {
          mapImages[`${category}`] = icon;
        })
      );
      await Promise.all(results);
    })
  );
};
